import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  imports: [CommonModule, MaterialModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  isLoading = this.loaderService.isLoading$;

  constructor(private loaderService: LoaderService) { }
}
